import { render } from "./EstoqueProd.vue?vue&type=template&id=735bb372&scoped=true"
import script from "./EstoqueProd.vue?vue&type=script&lang=js"
export * from "./EstoqueProd.vue?vue&type=script&lang=js"

import "./EstoqueProd.vue?vue&type=style&index=0&id=735bb372&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735bb372"]])

export default __exports__